export enum ActiveAssistStatus {
  None = 0,
  Activated = 1,
  Deactivated = 2,
  Pending = 3,
}
